import { Locale } from '../../../../src/modules/locale'
import { MinzeElement, EventListeners } from 'minze'
import { Font } from '../../../constants'

Locale.getInstance().registerKeySet('fr', 'lvc-satisfaction-popup', {
  title: 'Aidez-nous à améliorer votre expérience sur La Vitrine!',
  description: `Répondez à notre sondage et courez la chance de gagner 200$ en sorties culturelles!`,
  button: {
    text: 'Aller au sondage',
    href: 'https://qualtricsxmwq7tf6pzz.qualtrics.com/jfe/form/SV_80P0rVehONrTaaq',
  },
})
Locale.getInstance().registerKeySet('en', 'lvc-satisfaction-popup', {
  title: 'Help us improve your experience on La Vitrine!',
  description: `Complete our survey and get a chance to win $200 in cultural outings!`,
  button: {
    text: 'Go to survey',
    href: 'https://qualtricsxmwq7tf6pzz.qualtrics.com/jfe/form/SV_cMd7LQWYMPMMTHw',
  },
})

export interface LvcSatisfactionPopup {}

export class LvcSatisfactionPopup extends MinzeElement {
  onClose = () => {
    this.remove()
  }
  handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      this.onClose()
    }
  }

  onSurveyClick = () => {
    // Open survey in new tab
    window.open(Locale.getInstance().getKey('lvc-satisfaction-popup.button.href'), '_blank')
    this.onClose()
  }

  onOverlayClick = (event: Event) => {
    // Check if the click was directly on the overlay (not on the modal content)
    if (event.target === event.currentTarget) {
      this.onClose()
    }
  }

  onDestroy() {
    window.removeEventListener('keydown', this.handleKeyDown)
  }

  html = () => {
    return /*html*/ `
    <div class="satisfaction-popup-overlay" id="overlay">
      <div class="satisfaction-popup-modal">
        <div class="satisfaction-popup-header">
          <h3 class="satisfaction-popup-title">${Locale.getInstance().getKey('lvc-satisfaction-popup.title')}</h3>
          <button class="satisfaction-popup-close" id="close-button"><lvc-close-icon width="24" height="24"></lvc-close-icon></button>
        </div>
        <div class="popup-content">
          <p class="popup-description">
            ${Locale.getInstance().getKey('lvc-satisfaction-popup.description')}
          </p>
          <div class="popup-actions">
            <button id="survey-button" class="survey-button">
              ${Locale.getInstance().getKey('lvc-satisfaction-popup.button.text')}
            </button>
          </div>
        </div>
      </div>
    </div>
    `
  }

  css = () => `
    :host {
      display: block;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 100000;
    }

    .satisfaction-popup-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,0.25);
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .satisfaction-popup-modal {
      background: #fff;
      padding: 24px;
      border-radius: 12px;
      max-width: 500px;
      width: 90%;
      max-height: 90vh;
      overflow-y: auto;
      position: relative;
    }

    .satisfaction-popup-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
    }

    .satisfaction-popup-title {
      font-family: ${Font.family};
      font-style: normal;
      font-weight: ${Font.weight.extraBold};
      font-size: 24px;
      line-height: 100%;
      color: #1E007D;
      margin: 0;
      padding-right: 36px;
    }

    .satisfaction-popup-close {
      position: absolute;
      top: 16px;
      right: 16px;
      background: none;
      border: none;
      cursor: pointer;
      padding: 0;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: transform 0.2s ease;
    }

    .satisfaction-popup-close:hover {
      transform: scale(1.05);
    }

    .popup-content {
      padding: 0;
    }

    .popup-description {
      font-family: ${Font.family};
      font-style: normal;
      font-weight: ${Font.weight.regular};
      font-size: 16px;
      line-height: 150%;
      color: #333;
      margin-bottom: 24px;
    }

    .popup-actions {
      display: flex;
      justify-content: center;
    }

    .survey-button {
      font-family: ${Font.family};
      font-style: normal;
      font-weight: ${Font.weight.medium};
      font-size: 16px;
      line-height: 120%;
      color: #fff;
      background-color: #1E007D;
      border: none;
      border-radius: 999px;
      padding: 13px 24px;
      cursor: pointer;
      transition: background-color 0.2s ease;
    }

    .survey-button:hover {
      background-color: #2A0AA4;
    }

    .survey-button:focus {
      outline: 2px solid #1E007D;
      outline-offset: 2px;
    }

    @media screen and (max-width: 768px) {
      .satisfaction-popup-modal {
        width: 95%;
        padding: 16px;
      }
      
      .satisfaction-popup-title {
        font-size: 20px;
      }
      
      .popup-description {
        font-size: 14px;
      }
      
      .survey-button {
        font-size: 14px;
        padding: 11px 20px;
      }
    }
  `

  eventListeners: EventListeners = [
    ['#close-button', 'click', this.onClose],
    ['#overlay', 'click', this.onOverlayClick],
    ['#survey-button', 'click', this.onSurveyClick],
    [window, 'keydown', event => this.handleKeyDown(event as KeyboardEvent)],
  ]
}
